import { Fragment } from 'react'
import type { DtsAggregatorDto } from '@dhl/mdp-api'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'

type Props = { config: DtsAggregatorDto }

export const OutboundAggregator = ({ config }: Props) => (
  <>
    <DataHeading title="Aggregator" />
    <DataRow title="outName" payload={config.outName} withCopy />
    {config.sftpServer && (
      <>
        <DataRow title="sftp/host" payload={presentDateOrDefault(config.sftpServer.createdOn)} />
        <DataRow title="sftp/host" payload={config.sftpServer.host} withCopy />
        <DataRow title="sftp/portNumber" payload={config.sftpServer.portNumber} withCopy />
        <DataRow title="sftp/serverName" payload={config.sftpServer.serverName} withCopy />
        <DataRow title="sftp/username" payload={config.sftpServer.username} withCopy />
        <DataRow title="sftp/userAuthType" payload={config.sftpServer.userAuthType} />
      </>
    )}
    {config.aggregatorSettings?.map((setting) => (
      <Fragment key={setting.outName}>
        <DataHeading title={`setting "${setting.outName}"`} />
        <DataRow title="createdOn" payload={presentDateOrDefault(setting.createdOn)} />
        <DataRow title="outName" payload={setting.outName} withCopy />
        <DataRow title="aggregationKey" payload={setting.aggregationKey} withCopy />
        <DataRow title="backupDirectory" payload={setting.backupDirectory} withCopy />
        <DataRow title="maxRecords" payload={setting.maxRecords} withCopy />
        <DataRow title="path" payload={setting.path} withCopy />
        <DataRow title="filenamePattern" payload={setting.filenamePattern} withCopy />
        <DataRow title="temporaryDirectory" payload={setting.temporaryDirectory} withCopy />
        <DataRow title="temporaryPrefix" payload={setting.temporaryPrefix} withCopy />
        <DataRow title="schedule" payload={setting.schedule} withCopy />
        {setting.aggregatorFormat.CSV && (
          <>
            <DataRow
              title="CSV/colNames"
              payload={setting.aggregatorFormat.CSV.colNames?.join(', ')}
              withCopy
              alwaysShowEmpty
            />
            <DataRow title="CSV/delim" payload={setting.aggregatorFormat.CSV.delim} />
          </>
        )}
        {setting.aggregatorFormat.EDI && (
          <>
            <DataRow title="EDI/edifactRelease" payload={setting.aggregatorFormat.EDI.edifactRelease} withCopy />
            <DataRow title="EDI/syntaxSet" payload={setting.aggregatorFormat.EDI.syntaxSet} withCopy />
          </>
        )}
        {setting.aggregatorFormat.XML && (
          <>
            <DataRow title="XML/rootTag" payload={setting.aggregatorFormat.XML.rootTag} withCopy />
            <DataRow title="XML/xmlFormat" payload={setting.aggregatorFormat.XML.xmlFormat} withCopy />
          </>
        )}
      </Fragment>
    ))}
  </>
)
